
<app-header [data]="cityInformations"></app-header>

<div class="swiper-container" [swiper]="config" (indexChange)="onIndexChange($event)" >
  <div class="swiper-wrapper">
    
    <div class="swiper-slide"  *ngFor="let cityInformation of cityInformations"> 
    
      <app-weather city={{cityInformation.CityName}} cityID={{cityInformation.CityID}} 
        yrnoLocation={{cityInformation.yrnoLocation}} currentCity={{currentCity}} ></app-weather>
    
    </div>
  </div>

    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>
 <!-- 
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    -->
    <app-footer></app-footer>
</div> <!-- .cd-hero -->
